const colors = {
  white: {
    primary: 'rgb(255, 255, 255)',
  },
  black: {
    primary: 'rgb(0, 0, 0)',
    secondary: 'rgb(106, 106, 120)',
  },
  blue: {
    primary: 'rgb(0, 0, 255)',
    aliceblue: 'rgb(240, 248, 255)',
    clear: 'rgb(97, 218, 251)',
    azure: 'rgb(66, 129, 255)',
    violet: 'rgb(131, 111, 222)',
    blueDark: 'rgb(43, 43, 117)',
  },
  green: {
    primary: 'rgb(75, 196, 23)',
  },
  gray: {
    primary: 'rgb(128, 128, 128)',
    darker: 'rgb(40, 44, 52)',
    dark: 'rgb(147, 147, 162)',
    lighter: 'rgb(247, 248, 249)',
    light: 'rgb(200, 200, 200)',
    default: 'rgba(225, 225, 225, 0.2)',
  },

  linearGradient: 'linear-gradient(-135deg, rgb(21, 134, 248) 0%, rgb(138, 37, 228) 100%)',
  conentGradient: 'linear-gradient(to right, #6600cc 0%, #0066ff 100%)',
  bottomGradient: 'linear-gradient(to bottom, rgba(108, 37, 228,0) 0%,rgba(108, 37, 228,0.9) 100%)',
};

export default colors;
